const ENV_CONFIG = process.env;

export default {
    IDENTITY_BASE_URL: ENV_CONFIG.VUE_APP_IDENTITY_BASE_URL,
    UNIFICATION_BASE_URL: ENV_CONFIG.VUE_APP_UNIFICATION_BASE_URL,
    MHC_BASE_URL: ENV_CONFIG.VUE_APP_MHC_BASE_URL,
    MHC_DASHBOARD_URL: ENV_CONFIG.VUE_APP_MHC_DASHBOARD_URL,
    MARKETING_BASE_URL: ENV_CONFIG.VUE_APP_MARKETING_BASE_URL,
    KEYCLOAK_URL: ENV_CONFIG.VUE_APP_KEYCLOAK_URL,
    KEYCLOAK_REALM: ENV_CONFIG.VUE_APP_KEYCLOAK_REALM,
    KEYCLOAK_CLIENT_ID: ENV_CONFIG.VUE_APP_KEYCLOAK_CLIENT_ID,
    SPLIT_AUTHORIZATION_KEY: ENV_CONFIG.VUE_APP_SPLIT_IO_KEYS,
    MARKETING_LEGACY_APPLICATION_URL: ENV_CONFIG.VUE_APP_MARKETING_LEGACY_APPLICATION_URL,
    MARKETING_NEW_APPLICATION_URL: ENV_CONFIG.VUE_APP_MARKETING_NEW_APPLICATION_URL,
    SERVICE_LEGACY_APPLICATION_URL: ENV_CONFIG.VUE_APP_SERVICE_LEGACY_APPLICATION_URL,
    SERVICE_APPLICATION_URL: ENV_CONFIG.VUE_APP_SERVICE_APPLICATION_URL,
    COMMERCE_APPLICATION_URL: ENV_CONFIG.VUE_APP_COMMERCE_APPLICATION_URL,
    KEYCLOAK_REFRESH_TOKEN: ENV_CONFIG.VUE_APP_KEYCLOAK_REFRESH_TOKEN,
    NOTIFICATION_BASE_URL: ENV_CONFIG.VUE_APP_NOTIFICATION_BASE_URL,
    HUBSPOT_CHAT_HOST: ENV_CONFIG.VUE_APP_HUBSPOT_CHAT_HOST,
    HUBSPOT_PORTAL_ID: ENV_CONFIG.VUE_APP_HUBSPOT_PORTAL_ID
  }
